import {
  DefaultError,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query"
import {
  AddCustomerCardReq,
  AddCustomerCardRes,
  AttachCustomerTagReq,
  AttachCustomerTagRes,
  AttachNewCustomerTagReq,
  AttachNewCustomerTagRes,
  BulkGenerateStatementsForCustomersReq,
  BulkGenerateStatementsForCustomersRes,
  BulkUpsertCustomerContactsReq,
  BulkUpsertCustomerContactsRes,
  BulkUpsertCustomersReq,
  BulkUpsertCustomersRes,
  BulkUpsertJobsReq,
  BulkUpsertJobsRes,
  ConvertToJobReq,
  ConvertToJobRes,
  CountCustomersForBulkStatementReq,
  CountCustomersForBulkStatementRes,
  CreateCustomerContactReq,
  CreateCustomerContactRes,
  CreateCustomerInteractionReq,
  CreateCustomerInteractionRes,
  CreateCustomerReq,
  CreateCustomerRes,
  CreateJobReq,
  CreateJobRes,
  DeactivateCustomerContactReq,
  DeactivateCustomerContactRes,
  DeleteCustomerCardReq,
  DeleteCustomerCardRes,
  DetachCustomerTagReq,
  DetachCustomerTagRes,
  DuplicateCustomerReq,
  DuplicateCustomerRes,
  EmailAllInStatementRunReq,
  EmailAllInStatementRunRes,
  EmailContractorRewardsInvitationReq,
  EmailContractorRewardsInvitationRes,
  EmailCustomerSaleHistoryPDFReq,
  EmailCustomerStatementPDFReq,
  EmailCustomerStatementPDFRes,
  EmailStatementRunReq,
  EmailStatementRunRes,
  EnrollCustomerInFanBuilderLoyaltyReq,
  EnrollCustomerInFanBuilderLoyaltyRes,
  GenerateAndSendIndividualCustomerStatementReq,
  GenerateAndSendIndividualCustomerStatementRes,
  GenerateNextJobIdentifierReq,
  GenerateNextJobIdentifierRes,
  GenerateStatementRunPdfsReq,
  GenerateStatementRunPdfsRes,
  GenerateStatementsForCustomersReq,
  GenerateStatementsForCustomersRes,
  GetCustomerCountForTierReq,
  GetCustomerCountForTierRes,
  GetCustomerFanBuilderLoyaltyReq,
  GetCustomerFanBuilderLoyaltyRes,
  GetCustomerReq,
  GetCustomerRes,
  GetCustomerSaleHistoryPDFReq,
  GetCustomerSaleHistoryPDFRes,
  GetCustomerSavedBankAccountsReq,
  GetCustomerSavedBankAccountsRes,
  GetCustomerSavedCardsReq,
  GetCustomerSavedCardsRes,
  GetJobCountForCustomerReq,
  GetJobCountForCustomerRes,
  GetLastStatementRunIdReq,
  GetLastStatementRunIdRes,
  GetLastStatementRunReq,
  GetLastStatementRunRes,
  GetLastStatementRunSendStatsReq,
  GetLastStatementRunSendStatsRes,
  GetStatementRunReq,
  GetStatementRunRes,
  GetStatementRunStatsReq,
  GetStatementRunStatsRes,
  ListCustomersForRepReq,
  ListCustomersForRepRes,
  ListInteractionsForCustomerReq,
  ListInteractionsForCustomerRes,
  ListPurchaseOrdersForCustomerReq,
  ListPurchaseOrdersForCustomerRes,
  MergeCustomersReq,
  MergeCustomersRes,
  ListStatementsForCustomerReq,
  ListStatementsForCustomerRes,
  MailBulkStatementRunReq,
  MailBulkStatementRunRes,
  SendACHPaymentEmailAndSmsReq,
  SendACHPaymentEmailAndSmsRes,
  UpdateCustomerCardReq,
  UpdateCustomerCardRes,
  UpdateCustomerContactReq,
  UpdateCustomerContactRes,
  UpdateCustomerContractorRewardsReq,
  UpdateCustomerContractorRewardsRes,
  UpdateCustomerCreditLimitReq,
  UpdateCustomerCreditLimitRes,
  UpdateCustomerExemptionsReq,
  UpdateCustomerExemptionsRes,
  UpdateCustomerFinanceChargeSettingReq,
  UpdateCustomerFinanceChargeSettingRes,
  UpdateCustomerFinancingTermReq,
  UpdateCustomerFinancingTermRes,
  UpdateCustomerGeneralInformationReq,
  UpdateCustomerGeneralInformationRes,
  UpdateCustomerIsActiveReq,
  UpdateCustomerIsActiveRes,
  UpdateCustomerIsOnCreditHoldReq,
  UpdateCustomerIsOnCreditHoldRes,
  UpdateCustomerNotesReq,
  UpdateCustomerNotesRes,
  UpdateCustomerPricingTierReq,
  UpdateCustomerPricingTierRes,
  UpdateCustomerRepReq,
  UpdateCustomerRepRes,
  UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq,
  UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodRes,
  UpdateCustomerSalesReminderReq,
  UpdateCustomerSalesReminderRes,
  UpdateCustomerShouldAutopayStatementBalancesReq,
  UpdateCustomerShouldAutopayStatementBalancesRes,
  UpdateCustomerShouldHidePricesOnInvoicesReq,
  UpdateCustomerShouldHidePricesOnInvoicesRes,
  UpdateCustomerShouldMailStatementsReq,
  UpdateCustomerShouldMailStatementsRes,
  UpdateCustomerShouldPrintInvoicesAndReceiptsReq,
  UpdateCustomerShouldPrintInvoicesAndReceiptsRes,
  UpdateCustomerShouldReceiveJobStatementsReq,
  UpdateCustomerShouldReceiveJobStatementsRes,
  UpdateCustomerShouldRequireCustomerContactReq,
  UpdateCustomerShouldRequireCustomerContactRes,
  UpdateCustomerShouldRequireInternalSaleNotesReq,
  UpdateCustomerShouldRequireInternalSaleNotesRes,
  UpdateCustomerShouldRequireJobReq,
  UpdateCustomerShouldRequireJobRes,
  UpdateCustomerShouldRequirePOReq,
  UpdateCustomerShouldRequirePORes,
  UpdateCustomerShouldRequireReceiptSignatureReq,
  UpdateCustomerShouldRequireReceiptSignatureRes,
  UpdateCustomerIsCardSurchargeExemptReq,
  UpdateCustomerIsCardSurchargeExemptRes,
  UpdateCustomerShouldRequireSaleNotesReq,
  UpdateCustomerShouldRequireSaleNotesRes,
  UpdateCustomerStatementInvoicesFormatReq,
  UpdateCustomerStatementInvoicesFormatRes,
  UpdateCustomerStatementTypeReq,
  UpdateCustomerStatementTypeRes,
  UpdateCustomerTypeReq,
  UpdateCustomerTypeRes,
  UnenrollCustomerFromFanBuilderLoyaltyReq,
  UnenrollCustomerFromFanBuilderLoyaltyRes,
  ValidateFanBuilderLoyaltyCouponReq,
  ValidateFanBuilderLoyaltyCouponRes,
} from "gen/api/customer/service_pb"
import { CustomerServiceClient } from "gen/api/customer/service_pb.client"
import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import { Tag } from "gen/tag/models_pb"
import { UUID } from "shared-ts/classes/uuid"

import { apiSlice, transport } from "./apiSlice"

const c = new CustomerServiceClient(transport)

const extendedApiSlice = apiSlice
  .enhanceEndpoints({
    addTagTypes: [
      "Customer",
      "CustomerCards",
      "CustomerBankAccounts",
      "StatementRun",
      "Interactions",
      "CustomerSaleHistoryPDF",
      "PricingTier",
      "StatementRunStats",
    ],
  })
  .injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
      getCustomer: builder.query<GetCustomerRes, GetCustomerReq>({
        query: (r) => c.getCustomer(r),
        providesTags: (_response, _error, request) => [
          {
            type: "Customer",
            id: request.id ? UUID.fromPB(request.id).toString() : "",
          },
        ],
      }),
      getCustomerSavedCards: builder.query<
        GetCustomerSavedCardsRes,
        GetCustomerSavedCardsReq
      >({
        query: (r) => c.getCustomerSavedCards(r),
        providesTags: (_response, _error, request) =>
          request.customerId
            ? [
                {
                  type: "CustomerCards",
                  id: UUID.idString(request.customerId),
                },
              ]
            : [],
      }),
      getCustomerSavedBankAccounts: builder.query<
        GetCustomerSavedBankAccountsRes,
        GetCustomerSavedBankAccountsReq
      >({
        query: (r) => c.getCustomerSavedBankAccounts(r),
        providesTags: (_response, _error, request) => [
          {
            type: "CustomerBankAccounts",
            id: UUID.idString(request.customerId),
          },
        ],
      }),
      sendACHPaymentEmailAndSms: builder.mutation<
        SendACHPaymentEmailAndSmsRes,
        SendACHPaymentEmailAndSmsReq
      >({
        query: (r) => c.sendACHPaymentEmailAndSms(r),
      }),
      getCustomerCountForTier: builder.query<
        GetCustomerCountForTierRes,
        GetCustomerCountForTierReq
      >({
        query: (r) => c.getCustomerCountForTier(r),
        providesTags: (_response, _error, request) => [
          {
            type: "Customer",
            id: request.pricingTierIdString ?? "",
          },
        ],
      }),
      getJobCountForCustomer: builder.query<
        GetJobCountForCustomerRes,
        GetJobCountForCustomerReq
      >({
        query: (r) => c.getJobCountForCustomer(r),
        providesTags: (_response, _error, request) => [
          {
            type: "Customer",
            id: UUID.idString(request.customerId),
          },
        ],
      }),
      getCustomerFanBuilderLoyalty: builder.query<
        GetCustomerFanBuilderLoyaltyRes,
        GetCustomerFanBuilderLoyaltyReq
      >({
        query: (r) => c.getCustomerFanBuilderLoyalty(r),
        providesTags: (_response, _error, request) => [
          {
            type: "Customer",
            id: UUID.idString(request.customerId),
          },
        ],
      }),
      enrollCustomerInFanBuilderLoyalty: builder.mutation<
        EnrollCustomerInFanBuilderLoyaltyRes,
        EnrollCustomerInFanBuilderLoyaltyReq
      >({
        query: (r) => c.enrollCustomerInFanBuilderLoyalty(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.idString(request.customerId) },
        ],
      }),
      unenrollCustomerFromFanBuilderLoyalty: builder.mutation<
        UnenrollCustomerFromFanBuilderLoyaltyRes,
        UnenrollCustomerFromFanBuilderLoyaltyReq
      >({
        query: (r) => c.unenrollCustomerFromFanBuilderLoyalty(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.idString(request.customerId) },
        ],
      }),
      validateFanBuilderLoyaltyCoupon: builder.mutation<
        ValidateFanBuilderLoyaltyCouponRes,
        ValidateFanBuilderLoyaltyCouponReq
      >({
        query: (r) => c.validateFanBuilderLoyaltyCoupon(r),
      }),
      generateNextJobIdentifier: builder.mutation<
        GenerateNextJobIdentifierRes,
        GenerateNextJobIdentifierReq
      >({
        query: (r) => c.generateNextJobIdentifier(r),
      }),
      listPurchaseOrdersForCustomer: builder.query<
        ListPurchaseOrdersForCustomerRes,
        ListPurchaseOrdersForCustomerReq
      >({
        query: (r) => c.listPurchaseOrdersForCustomer(r),
        // Id-scoped so mutations invalidating the customer (e.g. upsertSaleV3,
        // which creates POs server-side) refetch this list.
        providesTags: (_res, _err, r) =>
          r.customerId
            ? [{ type: "Customer", id: UUID.idString(r.customerId) }]
            : ["Customer"],
      }),
      listInteractionsForCustomer: builder.query<
        ListInteractionsForCustomerRes,
        ListInteractionsForCustomerReq
      >({
        query: (r) => c.listInteractionsForCustomer(r),
        providesTags: ["Interactions"],
      }),
      listStatementsForCustomer: builder.query<
        ListStatementsForCustomerRes,
        ListStatementsForCustomerReq
      >({
        query: (r) => c.listStatementsForCustomer(r),
      }),
      generateStatementsForCustomers: builder.mutation<
        GenerateStatementsForCustomersRes,
        GenerateStatementsForCustomersReq
      >({
        query: (r) => c.generateStatementsForCustomers(r),
        invalidatesTags: ["StatementRun"],
      }),
      generateAndSendIndividualCustomerStatement: builder.mutation<
        GenerateAndSendIndividualCustomerStatementRes,
        GenerateAndSendIndividualCustomerStatementReq
      >({
        query: (r) => c.generateAndSendIndividualCustomerStatement(r),
        invalidatesTags: ["StatementRun"],
      }),
      bulkGenerateStatementsForCustomers: builder.mutation<
        BulkGenerateStatementsForCustomersRes,
        BulkGenerateStatementsForCustomersReq
      >({
        query: (r) => c.bulkGenerateStatementsForCustomers(r),
        invalidatesTags: ["StatementRun"],
      }),
      createCustomer: builder.mutation<CreateCustomerRes, CreateCustomerReq>({
        query: (r) => c.createCustomer(r),
        invalidatesTags: ["PricingTier"],
      }),
      duplicateCustomer: builder.mutation<
        DuplicateCustomerReq,
        DuplicateCustomerRes
      >({
        query: (r) => c.duplicateCustomer(r),
        invalidatesTags: ["PricingTier"],
      }),
      countCustomersForBulkStatement: builder.mutation<
        CountCustomersForBulkStatementRes,
        CountCustomersForBulkStatementReq
      >({
        query: (r) => c.countCustomersForBulkStatement(r),
      }),
      createCustomerContact: builder.mutation<
        CreateCustomerContactRes,
        CreateCustomerContactReq
      >({
        query: (r) => c.createCustomerContact(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.fromPB(request.id!).toString() },
        ],
      }),
      createCustomerInteraction: builder.mutation<
        CreateCustomerInteractionRes,
        CreateCustomerInteractionReq
      >({
        query: (r) => c.createCustomerInteraction(r),
        invalidatesTags: ["Interactions"],
      }),
      createJob: builder.mutation<CreateJobRes, CreateJobReq>({
        query: (r) => c.createJob(r),
        invalidatesTags: ["Customer"],
      }),
      convertToJob: builder.mutation<ConvertToJobRes, ConvertToJobReq>({
        query: (r) => c.convertToJob(r),
        invalidatesTags: ["Customer"],
      }),
      mergeCustomers: builder.mutation<MergeCustomersRes, MergeCustomersReq>({
        query: (r) => c.mergeCustomers(r),
        invalidatesTags: ["Customer"],
      }),
      updateCustomerGeneralInformation: builder.mutation<
        UpdateCustomerGeneralInformationRes,
        UpdateCustomerGeneralInformationReq
      >({
        query: (r) => c.updateCustomerGeneralInformation(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.fromPB(request.id!).toString() },
          "PricingTier",
        ],
      }),
      updateCustomerExemptions: builder.mutation<
        UpdateCustomerExemptionsRes,
        UpdateCustomerExemptionsReq
      >({
        query: (r) => c.updateCustomerExemptions(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.fromPB(request.id!).toString() },
        ],
      }),
      updateCustomerRequirePO: builder.mutation<
        UpdateCustomerShouldRequirePORes,
        UpdateCustomerShouldRequirePOReq
      >({
        query: (r) => c.updateCustomerShouldRequirePO(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.fromPB(request.id!).toString() },
        ],
        onQueryStarted: async (
          request,
          { dispatch, queryFulfilled, getState }
        ) => {
          const patchResults = extendedApiSlice.util
            .selectInvalidatedBy(getState(), [
              { type: "Customer", id: UUID.fromPB(request.id!).toString() },
            ])
            .filter(({ endpointName }) => endpointName === "getCustomer")
            .map(({ originalArgs }) =>
              dispatch(
                extendedApiSlice.util.updateQueryData(
                  "getCustomer",
                  originalArgs,
                  ({ customer }) => {
                    if (!customer) {
                      return
                    }

                    customer.shouldRequirePo = request.shouldRequirePo
                  }
                )
              )
            )

          try {
            await queryFulfilled
          } catch {
            for (const patchResult of patchResults) {
              patchResult.undo()
            }
          }
        },
      }),
      updateCustomerRequireCustomerContact: builder.mutation<
        UpdateCustomerShouldRequireCustomerContactRes,
        UpdateCustomerShouldRequireCustomerContactReq
      >({
        query: (r) => c.updateCustomerShouldRequireCustomerContact(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.fromPB(request.id!).toString() },
        ],
        onQueryStarted: async (
          request,
          { dispatch, queryFulfilled, getState }
        ) => {
          const patchResults = extendedApiSlice.util
            .selectInvalidatedBy(getState(), [
              { type: "Customer", id: UUID.fromPB(request.id!).toString() },
            ])
            .filter(({ endpointName }) => endpointName === "getCustomer")
            .map(({ originalArgs }) =>
              dispatch(
                extendedApiSlice.util.updateQueryData(
                  "getCustomer",
                  originalArgs,
                  ({ customer }) => {
                    if (!customer) {
                      return
                    }

                    customer.shouldRequireCustomerContact =
                      request.shouldRequireCustomerContact
                  }
                )
              )
            )

          try {
            await queryFulfilled
          } catch {
            for (const patchResult of patchResults) {
              patchResult.undo()
            }
          }
        },
      }),
      updateCustomerRequireSaleNote: builder.mutation<
        UpdateCustomerShouldRequireSaleNotesRes,
        UpdateCustomerShouldRequireSaleNotesReq
      >({
        query: (r) => c.updateCustomerShouldRequireSaleNotes(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.fromPB(request.id!).toString() },
        ],
        onQueryStarted: async (
          request,
          { dispatch, queryFulfilled, getState }
        ) => {
          const patchResults = extendedApiSlice.util
            .selectInvalidatedBy(getState(), [
              { type: "Customer", id: UUID.fromPB(request.id!).toString() },
            ])
            .filter(({ endpointName }) => endpointName === "getCustomer")
            .map(({ originalArgs }) =>
              dispatch(
                extendedApiSlice.util.updateQueryData(
                  "getCustomer",
                  originalArgs,
                  ({ customer }) => {
                    if (!customer) {
                      return
                    }

                    customer.shouldRequireSaleNotes =
                      request.shouldRequireSaleNotes
                  }
                )
              )
            )

          try {
            await queryFulfilled
          } catch {
            for (const patchResult of patchResults) {
              patchResult.undo()
            }
          }
        },
      }),
      updateCustomerRequireInternalSaleNote: builder.mutation<
        UpdateCustomerShouldRequireInternalSaleNotesRes,
        UpdateCustomerShouldRequireInternalSaleNotesReq
      >({
        query: (r) => c.updateCustomerShouldRequireInternalSaleNotes(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.fromPB(request.id!).toString() },
        ],
        onQueryStarted: async (
          request,
          { dispatch, queryFulfilled, getState }
        ) => {
          const patchResults = extendedApiSlice.util
            .selectInvalidatedBy(getState(), [
              { type: "Customer", id: UUID.fromPB(request.id!).toString() },
            ])
            .filter(({ endpointName }) => endpointName === "getCustomer")
            .map(({ originalArgs }) =>
              dispatch(
                extendedApiSlice.util.updateQueryData(
                  "getCustomer",
                  originalArgs,
                  ({ customer }) => {
                    if (!customer) {
                      return
                    }

                    customer.shouldRequireInternalSaleNotes =
                      request.shouldRequireInternalSaleNotes
                  }
                )
              )
            )

          try {
            await queryFulfilled
          } catch {
            for (const patchResult of patchResults) {
              patchResult.undo()
            }
          }
        },
      }),
      updateCustomerPrintInvoicesAndReceipts: builder.mutation<
        UpdateCustomerShouldPrintInvoicesAndReceiptsRes,
        UpdateCustomerShouldPrintInvoicesAndReceiptsReq
      >({
        query: (r) => c.updateCustomerShouldPrintInvoicesAndReceipts(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.fromPB(request.id!).toString() },
        ],
        onQueryStarted: async (
          request,
          { dispatch, queryFulfilled, getState }
        ) => {
          const patchResults = extendedApiSlice.util
            .selectInvalidatedBy(getState(), [
              { type: "Customer", id: UUID.fromPB(request.id!).toString() },
            ])
            .filter(({ endpointName }) => endpointName === "getCustomer")
            .map(({ originalArgs }) =>
              dispatch(
                extendedApiSlice.util.updateQueryData(
                  "getCustomer",
                  originalArgs,
                  ({ customer }) => {
                    if (!customer) {
                      return
                    }

                    customer.shouldPrintInvoicesAndReceipts =
                      request.shouldPrintInvoicesAndReceipts
                  }
                )
              )
            )

          try {
            await queryFulfilled
          } catch {
            for (const patchResult of patchResults) {
              patchResult.undo()
            }
          }
        },
      }),
      updateCustomerNotes: builder.mutation<
        UpdateCustomerNotesRes,
        UpdateCustomerNotesReq
      >({
        query: (r) => c.updateCustomerNotes(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.fromPB(request.id!).toString() },
        ],
      }),
      updateCustomerIsActive: builder.mutation<
        UpdateCustomerIsActiveRes,
        UpdateCustomerIsActiveReq
      >({
        query: (r) => c.updateCustomerIsActive(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.fromPB(request.id!).toString() },
        ],
      }),
      updateCustomerFinancingTerm: builder.mutation<
        UpdateCustomerFinancingTermRes,
        UpdateCustomerFinancingTermReq
      >({
        query: (r) => c.updateCustomerFinancingTerm(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.fromPB(request.id!).toString() },
        ],
        onQueryStarted: async (
          request,
          { dispatch, queryFulfilled, getState }
        ) => {
          const patchResults = extendedApiSlice.util
            .selectInvalidatedBy(getState(), [
              { type: "Customer", id: UUID.fromPB(request.id!).toString() },
            ])
            .filter(({ endpointName }) => endpointName === "getCustomer")
            .map(({ originalArgs }) =>
              dispatch(
                extendedApiSlice.util.updateQueryData(
                  "getCustomer",
                  originalArgs,
                  ({ customer }) => {
                    if (!customer) {
                      return
                    }

                    customer.financingTermIdString =
                      request.financingTermIdString
                  }
                )
              )
            )

          try {
            await queryFulfilled
          } catch {
            for (const patchResult of patchResults) {
              patchResult.undo()
            }
          }
        },
      }),
      updateCustomerFinanceChargeSetting: builder.mutation<
        UpdateCustomerFinanceChargeSettingRes,
        UpdateCustomerFinanceChargeSettingReq
      >({
        query: (r) => c.updateCustomerFinanceChargeSetting(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.fromPB(request.id!).toString() },
        ],
        onQueryStarted: async (
          request,
          { dispatch, queryFulfilled, getState }
        ) => {
          const patchResults = extendedApiSlice.util
            .selectInvalidatedBy(getState(), [
              { type: "Customer", id: UUID.fromPB(request.id!).toString() },
            ])
            .filter(({ endpointName }) => endpointName === "getCustomer")
            .map(({ originalArgs }) =>
              dispatch(
                extendedApiSlice.util.updateQueryData(
                  "getCustomer",
                  originalArgs,
                  ({ customer }) => {
                    if (!customer) {
                      return
                    }

                    UUID.eqFromPB(
                      customer.financeChargeSettingId,
                      request.financeChargeSettingId
                    )
                  }
                )
              )
            )

          try {
            await queryFulfilled
          } catch {
            for (const patchResult of patchResults) {
              patchResult.undo()
            }
          }
        },
      }),
      updateCustomerAutopayStatementBalance: builder.mutation<
        UpdateCustomerShouldAutopayStatementBalancesRes,
        UpdateCustomerShouldAutopayStatementBalancesReq
      >({
        query: (r) => c.updateCustomerShouldAutopayStatementBalances(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.fromPB(request.id!).toString() },
        ],
        onQueryStarted: async (
          request,
          { dispatch, queryFulfilled, getState }
        ) => {
          const patchResults = extendedApiSlice.util
            .selectInvalidatedBy(getState(), [
              { type: "Customer", id: UUID.fromPB(request.id!).toString() },
            ])
            .filter(({ endpointName }) => endpointName === "getCustomer")
            .map(({ originalArgs }) =>
              dispatch(
                extendedApiSlice.util.updateQueryData(
                  "getCustomer",
                  originalArgs,
                  ({ customer }) => {
                    if (!customer) {
                      return
                    }

                    customer.shouldAutopayStatementBalances =
                      request.shouldAutopayStatementBalances
                  }
                )
              )
            )

          try {
            await queryFulfilled
          } catch {
            for (const patchResult of patchResults) {
              patchResult.undo()
            }
          }
        },
      }),
      updateCustomerMailStatements: builder.mutation<
        UpdateCustomerShouldMailStatementsRes,
        UpdateCustomerShouldMailStatementsReq
      >({
        query: (r) => c.updateCustomerShouldMailStatements(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.fromPB(request.id!).toString() },
        ],
        onQueryStarted: async (
          request,
          { dispatch, queryFulfilled, getState }
        ) => {
          const patchResults = extendedApiSlice.util
            .selectInvalidatedBy(getState(), [
              { type: "Customer", id: UUID.fromPB(request.id!).toString() },
            ])
            .filter(({ endpointName }) => endpointName === "getCustomer")
            .map(({ originalArgs }) =>
              dispatch(
                extendedApiSlice.util.updateQueryData(
                  "getCustomer",
                  originalArgs,
                  ({ customer }) => {
                    if (!customer) {
                      return
                    }

                    customer.shouldMailStatements = request.shouldMailStatements
                  }
                )
              )
            )

          try {
            await queryFulfilled
          } catch {
            for (const patchResult of patchResults) {
              patchResult.undo()
            }
          }
        },
      }),
      updateCustomerShouldRequireJob: builder.mutation<
        UpdateCustomerShouldRequireJobRes,
        UpdateCustomerShouldRequireJobReq
      >({
        query: (r) => c.updateCustomerShouldRequireJob(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.fromPB(request.id!).toString() },
        ],
        onQueryStarted: async (
          request,
          { dispatch, queryFulfilled, getState }
        ) => {
          const patchResults = extendedApiSlice.util
            .selectInvalidatedBy(getState(), [
              { type: "Customer", id: UUID.fromPB(request.id!).toString() },
            ])
            .filter(({ endpointName }) => endpointName === "getCustomer")
            .map(({ originalArgs }) =>
              dispatch(
                extendedApiSlice.util.updateQueryData(
                  "getCustomer",
                  originalArgs,
                  ({ customer }) => {
                    if (!customer) {
                      return
                    }

                    customer.shouldRequireJob = request.shouldRequireJob
                  }
                )
              )
            )

          try {
            await queryFulfilled
          } catch {
            for (const patchResult of patchResults) {
              patchResult.undo()
            }
          }
        },
      }),
      updateCustomerCreditLimit: builder.mutation<
        UpdateCustomerCreditLimitRes,
        UpdateCustomerCreditLimitReq
      >({
        query: (r) => c.updateCustomerCreditLimit(r),
        invalidatesTags: (_response, _error, request) => [
          {
            type: "Customer",
            id: UUID.fromPB(request.customerId!).toString(),
          },
        ],
      }),
      updateCustomerOnCreditHold: builder.mutation<
        UpdateCustomerIsOnCreditHoldRes,
        UpdateCustomerIsOnCreditHoldReq
      >({
        query: (r) => c.updateCustomerIsOnCreditHold(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.fromPB(request.id!).toString() },
        ],
      }),
      updateCustomerContact: builder.mutation<
        UpdateCustomerContactRes,
        UpdateCustomerContactReq
      >({
        query: (r) => c.updateCustomerContact(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.fromPB(request.id!).toString() },
        ],
      }),
      updateCustomerRep: builder.mutation<
        UpdateCustomerRepRes,
        UpdateCustomerRepReq
      >({
        query: (r) => c.updateCustomerRep(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.fromPB(request.id!).toString() },
        ],
      }),
      updateCustomerRestrictOutstandingInvoicesToStatementPeriod:
        builder.mutation<
          UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodRes,
          UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq
        >({
          query: (r) =>
            c.updateCustomerRestrictOutstandingInvoicesToStatementPeriod(r),
          invalidatesTags: (_response, _error, request) => [
            { type: "Customer", id: UUID.fromPB(request.id!).toString() },
          ],
          onQueryStarted: async (
            request,
            { dispatch, queryFulfilled, getState }
          ) => {
            const patchResults = extendedApiSlice.util
              .selectInvalidatedBy(getState(), [
                { type: "Customer", id: UUID.idString(request.id) },
              ])
              .filter(({ endpointName }) => endpointName === "getCustomer")
              .map(({ originalArgs }) =>
                dispatch(
                  extendedApiSlice.util.updateQueryData(
                    "getCustomer",
                    originalArgs,
                    ({ customer }) => {
                      if (!customer) {
                        return
                      }

                      customer.restrictOutstandingInvoicesToStatementPeriod =
                        request.restrictOutstandingInvoicesToStatementPeriod
                    }
                  )
                )
              )

            try {
              await queryFulfilled
            } catch {
              for (const patchResult of patchResults) {
                patchResult.undo()
              }
            }
          },
        }),
      deactivateCustomerContact: builder.mutation<
        DeactivateCustomerContactRes,
        DeactivateCustomerContactReq
      >({
        query: (r) => c.deactivateCustomerContact(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.fromPB(request.id!).toString() },
        ],
      }),
      deleteCustomerCard: builder.mutation<
        DeleteCustomerCardRes,
        DeleteCustomerCardReq
      >({
        query: (r) => c.deleteCustomerCard(r),
        invalidatesTags: (_response, _error, request) => [
          ...(request.customerId
            ? [
                {
                  type: "Customer" as const,
                  id: UUID.fromPB(request.customerId).toString(),
                },
                {
                  type: "CustomerCards" as const,
                  id: UUID.fromPB(request.customerId).toString(),
                },
                {
                  type: "CustomerBankAccounts" as const,
                  id: UUID.fromPB(request.customerId).toString(),
                },
              ]
            : []),
        ],
      }),
      addCustomerCard: builder.mutation<AddCustomerCardRes, AddCustomerCardReq>(
        {
          query: (r) => c.addCustomerCard(r),
          invalidatesTags: (_response, _error, request) => [
            ...(request.customerId
              ? [
                  {
                    type: "Customer" as const,
                    id: UUID.fromPB(request.customerId).toString(),
                  },
                  {
                    type: "CustomerCards" as const,
                    id: UUID.fromPB(request.customerId).toString(),
                  },
                ]
              : []),
          ],
        }
      ),
      updateCustomerCard: builder.mutation<
        UpdateCustomerCardRes,
        UpdateCustomerCardReq
      >({
        query: (r) => c.updateCustomerCard(r),
        invalidatesTags: (_response, _error, request) => [
          {
            type: "CustomerCards",
            id: UUID.idString(request.customerId),
          },
          {
            type: "CustomerBankAccounts",
            id: UUID.idString(request.customerId),
          },
        ],
      }),
      getLastStatementRun: builder.query<
        GetLastStatementRunRes,
        GetLastStatementRunReq
      >({
        query: (r) => c.getLastStatementRun(r),
        providesTags: () => [{ type: "StatementRun" }],
      }),
      getLastStatementRunSendStats: builder.query<
        GetLastStatementRunSendStatsRes,
        GetLastStatementRunSendStatsReq
      >({
        query: (r) => c.getLastStatementRunSendStats(r),
        providesTags: () => [{ type: "StatementRunStats" }],
      }),
      emailAllInStatementRun: builder.mutation<
        EmailAllInStatementRunRes,
        EmailAllInStatementRunReq
      >({
        query: (r) => c.emailAllInStatementRun(r),
      }),
      emailStatementRun: builder.mutation<
        EmailStatementRunRes,
        EmailStatementRunReq
      >({
        query: (r) => c.emailStatementRun(r),
        invalidatesTags: () => [{ type: "StatementRunStats" }],
      }),
      mailBulkStatementRun: builder.mutation<
        MailBulkStatementRunRes,
        MailBulkStatementRunReq
      >({
        query: (r) => c.mailBulkStatementRun(r),
      }),
      generateStatementRunPdfs: builder.mutation<
        GenerateStatementRunPdfsRes,
        GenerateStatementRunPdfsReq
      >({
        query: (r) => c.generateStatementRunPdfs(r),
        invalidatesTags: () => [{ type: "StatementRunStats" }],
      }),
      updateCustomerContractorRewards: builder.mutation<
        UpdateCustomerContractorRewardsRes,
        UpdateCustomerContractorRewardsReq
      >({
        query: (r) => c.updateCustomerContractorRewards(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.fromPB(request.customerId!).toString() },
        ],
      }),
      getCustomerSalesHistoryPDF: builder.query<
        GetCustomerSaleHistoryPDFRes,
        GetCustomerSaleHistoryPDFReq
      >({
        query: (r) => c.getCustomerSaleHistoryPDF(r),
        providesTags: (_response, _error, request) =>
          request.customerId
            ? [
                {
                  type: "CustomerSaleHistoryPDF",
                  id: UUID.fromPB(request.customerId).toString(),
                },
              ]
            : [],
      }),
      getStatementRun: builder.query<GetStatementRunRes, GetStatementRunReq>({
        query: (r) => c.getStatementRun(r),
        providesTags: () => [{ type: "StatementRun" }],
      }),
      getLastStatementRunId: builder.query<
        GetLastStatementRunIdRes,
        GetLastStatementRunIdReq
      >({
        query: (r) => c.getLastStatementRunId(r),
      }),
      getStatementRunStats: builder.query<
        GetStatementRunStatsRes,
        GetStatementRunStatsReq
      >({
        query: (r) => c.getStatementRunStats(r),
      }),
      emailCustomerSalesHistoryPDF: builder.mutation<
        EmailCustomerSaleHistoryPDFReq,
        EmailCustomerSaleHistoryPDFReq
      >({
        query: (r) => c.emailCustomerSaleHistoryPDF(r),
      }),
      emailCustomerStatementPDF: builder.mutation<
        EmailCustomerStatementPDFRes,
        EmailCustomerStatementPDFReq
      >({
        query: (r) => c.emailCustomerStatementPDF(r),
      }),
      emailContractorRewardsInvitation: builder.mutation<
        EmailContractorRewardsInvitationRes,
        EmailContractorRewardsInvitationReq
      >({
        query: (r) => c.emailContractorRewardsInvitation(r),
      }),
      updateCustomerShouldRequireReceiptSignature: builder.mutation<
        UpdateCustomerShouldRequireReceiptSignatureRes,
        UpdateCustomerShouldRequireReceiptSignatureReq
      >({
        query: (r) => c.updateCustomerShouldRequireReceiptSignature(r),
        invalidatesTags: (_response, _error, request) =>
          request.customerId
            ? [
                {
                  type: "Customer",
                  id: UUID.fromPB(request.customerId).toString(),
                },
              ]
            : [],
        onQueryStarted: async (
          request,
          { dispatch, queryFulfilled, getState }
        ) => {
          const patchResults = extendedApiSlice.util
            .selectInvalidatedBy(
              getState(),
              request.customerId
                ? [
                    {
                      type: "Customer",
                      id: UUID.fromPB(request.customerId).toString(),
                    },
                  ]
                : []
            )
            .filter(({ endpointName }) => endpointName === "getCustomer")
            .map(({ originalArgs }) =>
              dispatch(
                extendedApiSlice.util.updateQueryData(
                  "getCustomer",
                  originalArgs,
                  ({ customer }) => {
                    if (!customer) {
                      return
                    }

                    customer.signatureRequirement = request.signatureRequirement
                  }
                )
              )
            )

          try {
            await queryFulfilled
          } catch {
            for (const patchResult of patchResults) {
              patchResult.undo()
            }
          }
        },
      }),
      updateCustomerPricingTier: builder.mutation<
        UpdateCustomerPricingTierRes,
        UpdateCustomerPricingTierReq
      >({
        query: (r) => c.updateCustomerPricingTier(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.fromPB(request.customerId!).toString() },
        ],
      }),
      bulkUpsertCustomers: builder.mutation<
        BulkUpsertCustomersRes,
        BulkUpsertCustomersReq
      >({
        query: (r) => c.bulkUpsertCustomers(r),
        invalidatesTags: ["Customer"],
      }),
      bulkUpsertJobs: builder.mutation<BulkUpsertJobsRes, BulkUpsertJobsReq>({
        query: (r) => c.bulkUpsertJobs(r),
        invalidatesTags: ["Customer"],
      }),
      bulkUpsertCustomerContacts: builder.mutation<
        BulkUpsertCustomerContactsRes,
        BulkUpsertCustomerContactsReq
      >({
        query: (r) => c.bulkUpsertCustomerContacts(r),
        invalidatesTags: ["Customer"],
      }),
      updateCustomerSalesReminder: builder.mutation<
        UpdateCustomerSalesReminderRes,
        UpdateCustomerSalesReminderReq
      >({
        query: (r) => c.updateCustomerSalesReminder(r),
        invalidatesTags: (_response, _error, request) => [
          {
            type: "Customer",
            id: request.id ? UUID.fromPB(request.id).toString() : "",
          },
        ],
      }),
      listCustomersForRep: builder.query<
        ListCustomersForRepRes,
        ListCustomersForRepReq
      >({
        query: (r) => c.listCustomersForRep(r),
      }),
      updateCustomerShouldReceiveJobStatements: builder.mutation<
        UpdateCustomerShouldReceiveJobStatementsRes,
        UpdateCustomerShouldReceiveJobStatementsReq
      >({
        query: (r) => c.updateCustomerShouldReceiveJobStatements(r),
        invalidatesTags: (_response, _error, request) =>
          request.id
            ? [
                {
                  type: "Customer",
                  id: UUID.fromPB(request.id).toString(),
                },
              ]
            : [],
        onQueryStarted: async (
          request,
          { dispatch, queryFulfilled, getState }
        ) => {
          const patchResults = extendedApiSlice.util
            .selectInvalidatedBy(
              getState(),
              request.id
                ? [
                    {
                      type: "Customer",
                      id: UUID.fromPB(request.id).toString(),
                    },
                  ]
                : []
            )
            .filter(({ endpointName }) => endpointName === "getCustomer")
            .map(({ originalArgs }) =>
              dispatch(
                extendedApiSlice.util.updateQueryData(
                  "getCustomer",
                  originalArgs,
                  ({ customer }) => {
                    if (!customer) {
                      return
                    }

                    customer.shouldReceiveJobStatements =
                      request.shouldReceiveJobStatements
                  }
                )
              )
            )

          try {
            await queryFulfilled
          } catch {
            for (const patchResult of patchResults) {
              patchResult.undo()
            }
          }
        },
      }),
      updateCustomerStatementInvoicesFormat: builder.mutation<
        UpdateCustomerStatementInvoicesFormatRes,
        UpdateCustomerStatementInvoicesFormatReq
      >({
        query: (r) => c.updateCustomerStatementInvoicesFormat(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.idString(request.id) },
        ],
        onQueryStarted: async (
          request,
          { dispatch, queryFulfilled, getState }
        ) => {
          const patchResults = extendedApiSlice.util
            .selectInvalidatedBy(getState(), [
              { type: "Customer", id: UUID.idString(request.id) },
            ])
            .filter(({ endpointName }) => endpointName === "getCustomer")
            .map(({ originalArgs }) =>
              dispatch(
                extendedApiSlice.util.updateQueryData(
                  "getCustomer",
                  originalArgs,
                  ({ customer }) => {
                    if (!customer) {
                      return
                    }

                    customer.statementInvoicesFormat =
                      request.statementInvoicesFormat
                  }
                )
              )
            )

          try {
            await queryFulfilled
          } catch {
            for (const patchResult of patchResults) {
              patchResult.undo()
            }
          }
        },
      }),
      updateCustomerShouldHidePricesOnInvoices: builder.mutation<
        UpdateCustomerShouldHidePricesOnInvoicesRes,
        UpdateCustomerShouldHidePricesOnInvoicesReq
      >({
        query: (r) => c.updateCustomerShouldHidePricesOnInvoices(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.idString(request.id) },
        ],
        onQueryStarted: async (
          request,
          { dispatch, queryFulfilled, getState }
        ) => {
          const patchResults = extendedApiSlice.util
            .selectInvalidatedBy(getState(), [
              { type: "Customer", id: UUID.idString(request.id) },
            ])
            .filter(({ endpointName }) => endpointName === "getCustomer")
            .map(({ originalArgs }) =>
              dispatch(
                extendedApiSlice.util.updateQueryData(
                  "getCustomer",
                  originalArgs,
                  ({ customer }) => {
                    if (!customer) {
                      return
                    }

                    customer.shouldHidePricesOnInvoices =
                      request.shouldHidePricesOnInvoices
                  }
                )
              )
            )

          try {
            await queryFulfilled
          } catch {
            for (const patchResult of patchResults) {
              patchResult.undo()
            }
          }
        },
      }),
      updateCustomerStatementType: builder.mutation<
        UpdateCustomerStatementTypeRes,
        UpdateCustomerStatementTypeReq
      >({
        query: (r) => c.updateCustomerStatementType(r),
        invalidatesTags: ["Customer"],
      }),
      updateCustomerType: builder.mutation<
        UpdateCustomerTypeRes,
        UpdateCustomerTypeReq
      >({
        query: (r) => c.updateCustomerType(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.idString(request.id) },
        ],
        onQueryStarted: async (
          request,
          { dispatch, queryFulfilled, getState }
        ) => {
          const patchResults = extendedApiSlice.util
            .selectInvalidatedBy(getState(), [
              { type: "Customer", id: UUID.idString(request.id) },
            ])
            .filter(({ endpointName }) => endpointName === "getCustomer")
            .map(({ originalArgs }) =>
              dispatch(
                extendedApiSlice.util.updateQueryData(
                  "getCustomer",
                  originalArgs,
                  ({ customer }) => {
                    if (!customer) {
                      return
                    }

                    customer.type = request.type
                  }
                )
              )
            )

          try {
            await queryFulfilled
          } catch {
            for (const patchResult of patchResults) {
              patchResult.undo()
            }
          }
        },
      }),
      updateCustomerIsCardSurchargeExempt: builder.mutation<
        UpdateCustomerIsCardSurchargeExemptRes,
        UpdateCustomerIsCardSurchargeExemptReq
      >({
        query: (r) => c.updateCustomerIsCardSurchargeExempt(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Customer", id: UUID.idString(request.id) },
        ],
        onQueryStarted: async (
          request,
          { dispatch, queryFulfilled, getState }
        ) => {
          const patchResults = extendedApiSlice.util
            .selectInvalidatedBy(getState(), [
              { type: "Customer", id: UUID.idString(request.id) },
            ])
            .filter(({ endpointName }) => endpointName === "getCustomer")
            .map(({ originalArgs }) =>
              dispatch(
                extendedApiSlice.util.updateQueryData(
                  "getCustomer",
                  originalArgs,
                  ({ customer }) => {
                    if (!customer) {
                      return
                    }

                    customer.isCardSurchargeExempt =
                      request.isCardSurchargeExempt
                  }
                )
              )
            )

          try {
            await queryFulfilled
          } catch {
            for (const patchResult of patchResults) {
              patchResult.undo()
            }
          }
        },
      }),
    }),
  })

export const {
  useGetCustomerQuery,
  useLazyGetCustomerQuery,
  useGetCustomerCountForTierQuery,
  useGetCustomerSavedCardsQuery,
  useGetCustomerSavedBankAccountsQuery,
  useSendACHPaymentEmailAndSmsMutation,
  useGetJobCountForCustomerQuery,
  useGetCustomerFanBuilderLoyaltyQuery,
  useGetLastStatementRunIdQuery,
  useLazyGetCustomerSavedCardsQuery,
  useLazyGetCustomerSavedBankAccountsQuery,
  useListPurchaseOrdersForCustomerQuery,
  useLazyListPurchaseOrdersForCustomerQuery,
  useListInteractionsForCustomerQuery,
  useLazyListInteractionsForCustomerQuery,
  useListStatementsForCustomerQuery,
  useGetStatementRunQuery,
  useCreateCustomerMutation,
  useCountCustomersForBulkStatementMutation,
  useDuplicateCustomerMutation,
  useEnrollCustomerInFanBuilderLoyaltyMutation,
  useUnenrollCustomerFromFanBuilderLoyaltyMutation,
  useValidateFanBuilderLoyaltyCouponMutation,
  useCreateCustomerContactMutation,
  useCreateCustomerInteractionMutation,
  useCreateJobMutation,
  useUpdateCustomerAutopayStatementBalanceMutation,
  useUpdateCustomerContactMutation,
  useUpdateCustomerCreditLimitMutation,
  useUpdateCustomerExemptionsMutation,
  useUpdateCustomerFinanceChargeSettingMutation,
  useUpdateCustomerFinancingTermMutation,
  useUpdateCustomerGeneralInformationMutation,
  useUpdateCustomerIsActiveMutation,
  useUpdateCustomerMailStatementsMutation,
  useUpdateCustomerNotesMutation,
  useUpdateCustomerOnCreditHoldMutation,
  useUpdateCustomerPrintInvoicesAndReceiptsMutation,
  useUpdateCustomerShouldRequireJobMutation,
  useUpdateCustomerRequirePOMutation,
  useUpdateCustomerRequireCustomerContactMutation,
  useUpdateCustomerRequireSaleNoteMutation,
  useUpdateCustomerRequireInternalSaleNoteMutation,
  useUpdateCustomerRepMutation,
  useDeactivateCustomerContactMutation,
  useDeleteCustomerCardMutation,
  useAddCustomerCardMutation,
  useUpdateCustomerCardMutation,
  useGetLastStatementRunQuery,
  useLazyGetLastStatementRunQuery,
  useMailBulkStatementRunMutation,
  useUpdateCustomerContractorRewardsMutation,
  useGetCustomerSalesHistoryPDFQuery,
  useLazyGetCustomerSalesHistoryPDFQuery,
  useEmailCustomerSalesHistoryPDFMutation,
  useEmailAllInStatementRunMutation,
  useEmailCustomerStatementPDFMutation,
  useEmailContractorRewardsInvitationMutation,
  useUpdateCustomerShouldRequireReceiptSignatureMutation,
  useUpdateCustomerPricingTierMutation,
  useUpdateCustomerRestrictOutstandingInvoicesToStatementPeriodMutation,
  useBulkUpsertCustomersMutation,
  useBulkUpsertJobsMutation,
  useBulkUpsertCustomerContactsMutation,
  useBulkGenerateStatementsForCustomersMutation,
  useUpdateCustomerSalesReminderMutation,
  useListCustomersForRepQuery,
  useUpdateCustomerShouldReceiveJobStatementsMutation,
  useUpdateCustomerStatementInvoicesFormatMutation,
  useUpdateCustomerShouldHidePricesOnInvoicesMutation,
  useUpdateCustomerStatementTypeMutation,
  useUpdateCustomerTypeMutation,
  useUpdateCustomerIsCardSurchargeExemptMutation,
  useGenerateStatementsForCustomersMutation,
  useEmailStatementRunMutation,
  useGetStatementRunStatsQuery,
  useConvertToJobMutation,
  useMergeCustomersMutation,
  useGenerateStatementRunPdfsMutation,
  useGenerateNextJobIdentifierMutation,
  useGetLastStatementRunSendStatsQuery,
  useGenerateAndSendIndividualCustomerStatementMutation,
} = extendedApiSlice

export function useListCustomerTagsQuery(customerId: PBUUID) {
  return useQuery({
    queryKey: ["customer-tags", customerId],
    queryFn: async () => {
      const { response } = await c.listCustomerTags({ customerId })
      return response
    },
  })
}

export function useAttachNewCustomerTagMutation() {
  const queryClient = useQueryClient()
  return useMutation<
    AttachNewCustomerTagRes,
    DefaultError,
    AttachNewCustomerTagReq
  >({
    mutationFn: async (req) => {
      const { response } = await c.attachNewCustomerTag(req)
      return response
    },
    onSettled: async (_res, _err, { customerId }) => {
      return await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ["customer-tags", customerId],
        }),
        queryClient.invalidateQueries({
          queryKey: ["search", "custom-price-rules"],
        }),
      ])
      return await queryClient.invalidateQueries({
        queryKey: ["customer-tags", customerId],
      })
    },
  })
}

export type OptimisticAttachCustomerTagReq = AttachCustomerTagReq & { tag: Tag }

export function useAttachCustomerTagMutation() {
  const queryClient = useQueryClient()
  return useMutation<
    AttachCustomerTagRes,
    DefaultError,
    OptimisticAttachCustomerTagReq
  >({
    mutationFn: async (req) => {
      const { response } = await c.attachCustomerTag(req)
      return response
    },
    onSettled: async (_res, _err, { customerId }) => {
      return await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ["customer-tags", customerId],
        }),
        queryClient.invalidateQueries({
          queryKey: ["search", "custom-price-rules"],
        }),
      ])
    },
  })
}

export function useDetachCustomerTagMutation() {
  const queryClient = useQueryClient()
  return useMutation<DetachCustomerTagRes, DefaultError, DetachCustomerTagReq>({
    mutationFn: async (req) => {
      const { response } = await c.detachCustomerTag(req)
      return response
    },
    onSettled: async (_res, _err, { customerId }) => {
      return await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ["customer-tags", customerId],
        }),
        queryClient.invalidateQueries({
          queryKey: ["search", "custom-price-rules"],
        }),
      ])
    },
  })
}

export function useGetActiveCustomerCountQuery() {
  return useQuery({
    queryKey: ["active-customer-count"],
    queryFn: async () => {
      const { response } = await c.getActiveCustomerCount({})
      return response
    },
  })
}

export function useGetCustomersQuery(customerIds: UUID[]) {
  const sortedCustomerIds = [...customerIds].sort((a, b) =>
    a.toString().localeCompare(b.toString())
  )
  return useQuery({
    queryKey: [
      "customers",
      ...sortedCustomerIds.map((customerId) => customerId.toString()),
    ],
    queryFn: () =>
      Promise.all(
        sortedCustomerIds.map(async (id) => {
          const { response } = await c.getCustomer({ id })
          return response
        })
      ),
  })
}
